import { useRootData } from './use-root-data';

/**
 * Hook to check if the user is a bot.
 */
export function useIsGoodBot() {
    return useRootData().device.isBot;
}
